import React from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";

const filterOptions = ["Equal", "Contains", "Greater", "Less"];

const FilterModal = ({ show, onHide, modalData, onApplyFilter, onRemoveFilter, onChange, claimTypeOptions = [] }) => {
  const { key, type, value } = modalData;
  const isClaimTypeFilter = key === "claim_type";

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="sm"
      centered
      dialogClassName="compact-modal"
    >
      <Modal.Header closeButton className="p-2">
        <Modal.Title style={{ fontSize: "1rem" }}>Filter {key?.replace(/_/g, " ")}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-2">
        <Form.Group className="mt-2">
          <Form.Label style={{ fontSize: "0.85rem" }}>{isClaimTypeFilter ? "Claim Type" : "Value"}</Form.Label>
          {isClaimTypeFilter ? (
            <Form.Select
              value={value}
              onChange={(e) => onChange("value", e.target.value)}
              size="sm"
              style={{ fontSize: "0.85rem" }}
            >
              <option value="">All</option>
              {(claimTypeOptions || []).map((claim) => (
                <option key={claim?.id} value={claim?.id}>{claim?.name}</option>
              ))}
            </Form.Select>
          ) : (
            <Form.Control
              type="text"
              value={value}
              onChange={(e) => onChange("value", e.target.value)}
              size="sm"
              style={{ fontSize: "0.85rem" }}
            />
          )}
        </Form.Group>
      </Modal.Body>
      <Modal.Footer className="p-1">
        <Button variant="outline-secondary" size="sm" onClick={() => onRemoveFilter(key)}>
          <FontAwesomeIcon icon={faTimes} /> Reset
        </Button>
        <Button variant="primary" size="sm" onClick={onApplyFilter}>
          <FontAwesomeIcon icon={faCheck} /> Apply
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default FilterModal;
